export const woStatusesToHideDownloadButtons = [
  50901, 50902, 50904, 20900, 50905,
];
